import Image from '@eliadmin/core/src/components/image/image-wrapped';
import type { SearchConfig } from '@eliadmin/core/src/components/header/search-bar/search-config-types';

export const SEARCH_CONFIG: SearchConfig = {
  mode: 'drawer',
  field: {
    leadingIcon: (
      <Image
        src="/images/icons/search-normal.svg"
        alt="Search"
        width={0}
        height={0}
        className="h-6 w-6 object-contain sm:h-7 sm:w-7 lg:h-8 lg:w-8"
      />
    ),
    buttonTextKey: 'text871',
    buttonClassName: 'h-12 px-[18px] sm:h-14 lg:h-[72px]',
    className: { input: { before: 'pl-4 sm:pl-[18px]', main: 'pl-12 sm:pl-[66px]' } },
  },
};
